


























import { Component, Prop, Vue } from 'vue-property-decorator'
import { receiptStatusMap } from '@/utils/status-map'

@Component
export default class StatusEffective extends Vue {
    statusMap = receiptStatusMap
    @Prop() status!: number
}
